import React, { Fragment } from "react"
import AutomaticDebitSkeleton from "../AutomaticDebitSkeleton"
import DefaultTitle from "shared/components/DefaultTitle"
import SelectNumberSkeleton from "./SelectNumberSkeleton"

const DetailingPosPreControleSkeleton = () => {
  return (
    <Fragment>
      <DefaultTitle>Detalhamento de chamadas</DefaultTitle>
      <AutomaticDebitSkeleton />
      <SelectNumberSkeleton />
    </Fragment>
  )
}

export default DetailingPosPreControleSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/DetailingPosPreControleSkeleton/index.js